// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__mIuK3","content":"Layout_content__ffqXr"};